export const UserMenuItems = [
  {
    label: 'SIGN IN',
    path: '/account/signin',
    target: '_self',
    id: 'rciHeaderSignIn',
  },
];
